import { render, staticRenderFns } from "./salaryEditModal.vue?vue&type=template&id=fa5ecbc6&scoped=true&"
import script from "./salaryEditModal.vue?vue&type=script&lang=js&"
export * from "./salaryEditModal.vue?vue&type=script&lang=js&"
import style0 from "./salaryEditModal.vue?vue&type=style&index=0&id=fa5ecbc6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5ecbc6",
  null
  
)

export default component.exports